"use strict";

// Preserve the Application widget lifecycle and the native DVM busy signal.
// Only its template is extended; no polling, request interception or PLC calls.
modulum("SquillaApplicationWidget", ["ApplicationWidget", "WidgetFactory"], function (context, cls) {
  cls.SquillaApplicationWidget = context.oo.Class(cls.ApplicationWidget, function () {
    return {
      __name: "SquillaApplicationWidget",
      __templateName: "SquillaApplicationWidget"
    };
  });
  cls.WidgetFactory.registerBuilder("Application", cls.SquillaApplicationWidget);
});
